// extracted by mini-css-extract-plugin
export default {"footer":"ntSx5BvwvCP2qFqaaQ8L","button":"Xm_cHXUb_nCN9Armbzdw","overlay":"G3DfITMawfCmMNmkZIPg","badge":"fjHP97pCGKKhn3ulX0Yw"};